<template>
    <div class="common-layout">
        <el-container>
            <el-aside :style="{ width: isOpen ? '300px' : '60px' }" class="sidebar">
                <img src="/media/images/ai_icon_white.svg" class="ai-icon">
                <div v-if="isOpen" class="menu-links">
                    <a href="https://www.deutscheinterim.com/datenschutz" target="_blank">Datenschutzerklärung</a>
                    <a href="https://www.deutscheinterim.com/impressum" target="_blank">Impressum</a>
                </div>
                <button class="hamburger-menu-button" type="button" @click="toggleMenu" :aria-expanded="isOpen">
                    <div :id="'nav-icon1'" :class="{ open: isOpen }">
                        <span></span>
                        <span></span>
                        <span></span>
                    </div>
                </button>
            </el-aside>
            <el-container style="height: 100vh;">
                <el-header>
                    <el-row :gutter="10" justify="end" class="header-wrapper">
                        <el-col :span="20">
                            <div class="logo-wrapper">
                                <a href='https://matchmaker.de'><img class="logo"
                                        src="/media/images/matchmaker/logo.svg" alt="Logo" /></a>
                                <span class="beta">BETA</span>
                            </div>
                        </el-col>
                        <el-col :span="4">
                            <div class="user-wrapper">
                                <el-row :gutter="1" justify="end">
                                    <el-col :span="6">
                                        <el-link type="primary" class="link register-link" :underline="false"
                                            href="https://matchmaker.deutscheinterim.com/register/check-email">register</el-link>
                                    </el-col>
                                    <!--
                                    <el-col :span="1" >
                                       <span class="dot"></span>
                                    </el-col>

                                    <el-col :span="6" v-if="!is_authenticated">
                                        <el-link type="primary" class="link" :underline="false" href='https://matchmaker.deutscheinterim.com/' target="_blank">login</el-link>
                                    </el-col>
                                    <el-col :span="6" v-if="is_authenticated">
                                        <el-link type="primary" class="link" :underline="false" href='https://matchmaker.deutscheinterim.com/logout' target="_blank">logout</el-link>
                                    </el-col>
                                    <el-col :span="11" v-if="is_authenticated">
                                       <img class="avatar" :src="userAvatar" alt="Avatar" />
                                    </el-col>
                                    -->
                                </el-row>
                            </div>
                        </el-col>
                    </el-row>
                </el-header>
                <el-main class="main-wrapper">
                    <div class="start-wrapper" v-if="startWrapper">
                        <el-row :gutter="10" class="main-wrapper">
                            <el-col :span="24" class="main-title">
                                Für welche Aufgaben, Positionen oder<br>
                                Projekte suchen Sie Fachleute?
                            </el-col>
                            <el-col :span="24" class="subtitle">
                                Finden Sie mit Matchmaker schnell und unkompliziert freiberufliche Professionals,
                                selbstständige Berater, erfahrene Führungskräfte, spezialisierte<br>
                                Projektleiter sowie hochqualifizierteInterim Managerinnen und Manager, welche die
                                Anforderungen Ihres Unternehmens optimal erfüllen.<br>
                                Bringen Sie Ihre Projekte erfolgreich voran.
                            </el-col>
                            <el-col :span="24" class="input-wrapper">
                                <div class="input-group">
                                    <input v-model="question" class="question-input" placeholder="Ich suche..."
                                        v-on:keyup.enter="startSearch" />
                                    <button class="search-btn" @click="startSearch"><img class='arrow-image'
                                            src="/media/images/matchmaker/arrow.svg"></button>
                                </div>
                            </el-col>
                            <el-col :span="24" class="footer-wrapper">
                                Ein Service der <a class="di-link" href="https://www.deutscheinterim.com" target="_blank">Deutschen
                                    Interim AG</a>
                            </el-col>
                        </el-row>
                    </div>
                    <div class="chatbot-wrapper" v-if="!startWrapper">
                        <el-row :gutter="10" class="chat-wrapper">
                            <el-col span:="24">
                                <el-row :gutter="10" class="messages-wrapper" v-for="message in messages">
                                    <el-col :span="1" class="message-avatar"
                                        v-if="is_authenticated && message.sender == 'user'">
                                        <img class="avatar" :src="userAvatar" alt="Avatar" />
                                    </el-col>
                                    <el-col :span="1" class="message-avatar"
                                        v-if="!is_authenticated && message.sender == 'user'">
                                        <img class="avatar" src="media/images/profile_image_with_background.png"
                                            alt="Avatar" />
                                    </el-col>
                                    <el-col :span="1" class="message-avatar" v-if="message.sender == 'ai'">
                                        <img class="avatar" src="media/images/matchmaker/ai_avatar.svg" alt="Avatar" />
                                    </el-col>
                                    <el-col :span="23" class="message-content">
                                        <span v-html="message.text"></span>
                                    </el-col>
                                </el-row>
                                <el-row :gutter="10" class="messages-wrapper loading" v-if="loading">
                                    <el-col :span="24" class="message-content-loader">
                                        <div class="loader"></div>
                                    </el-col>
                                </el-row>
                            </el-col>
                        </el-row>
                        <el-row :gutter="10" class="input-wrapper-row">
                            <el-col :span="24" class="input-wrapper">
                                <div class="input-group">
                                    <input v-model="question" class="question-input" placeholder="matchmaker fragen"
                                        v-on:keyup.enter="startSearch" />
                                    <button class="search-btn" @click="startSearch"><img class='arrow-image'
                                            src="/media/images/matchmaker/arrow.svg"></button>
                                </div>
                            </el-col>
                            <el-col :span="24" class="footer-wrapper">
                                Ein Service der <a class="di-link" href="https://www.deutscheinterim.com" target="_blank">Deutschen
                                    Interim AG</a>
                            </el-col>
                        </el-row>
                    </div>
                </el-main>
            </el-container>
        </el-container>
        <el-dialog v-model="dialogTableVisible" title="Chose register option" width="800">
            <el-row :gutter="10">
                <el-col :span="24" class="register-link-wrapper">
                    <el-link class="client" :underline="false" href="https://matchmaker.">Client</el-link>
                    <el-link class="pool-member" :underline="false"
                        href="https://matchmaker.deutscheinterim.com/register/check-email">Candidate</el-link>
                </el-col>
            </el-row>

        </el-dialog>
    </div>

</template>

<script>
import axios from 'axios';
import { el, sl } from 'element-plus/es/locales.mjs';

const toggleMenu = () => {
    isOpen.value = !isOpen.value;
};

export default {
    data() {
        return {
            messages: [],
            question: '',
            loading: false,
            thread_id: null,
            run_id: null,
            startWrapper: true,
            is_authenticated: this.$page.props.is_authenticated,
            dialogTableVisible: false,
            userAvatar: this.$page.props.auth.user_avatar,
            isOpen: false,
        };
    },
    methods: {
        startSearch() {
            if (this.question.length > 0) {
                this.startWrapper = false;
                this.messages.push({
                    text: this.question,
                    sender: 'user',
                    type: 'send'
                });

                const message = this.question;
                this.question = '';
                this.sendMessage(message);
            }
        },
        async sendMessage(message) {
            this.loading = true;

            try {
                const response = await axios.post('/ai/response', {
                    question: message,
                    thread_id: this.thread_id,
                    run_id: this.run_id,
                });
                this.loading = false;
                this.thread_id = response.data.thread_id;
                this.run_id = response.data.run_id;

                const arr = response.data.assistant_message.map(msg => ({
                    text: msg,
                    sender: 'ai',
                    type: 'response',
                }));
                this.messages = this.messages.concat(arr);

            } catch (error) {
                console.error(error);
            }
            this.loading = false;
        },
        toggleMenu() {
            this.isOpen = !this.isOpen;
            const sidebar = document.querySelector('.sidebar');
            sidebar.style.width = this.isOpen ? '300px' : '60px';
        },
    },
};

</script>
<style lang="css" scoped>
* {
    font-family: Barlow;
}

.common-layout {
    background-color: #fff !important;
}

.sidebar {
    background-color: #41ABC4;
    width: 60px;
    transition: width 0.3s ease-in-out;
    overflow: hidden;
}

.hamburger-menu-button {
    background: none;
    border: none;
    cursor: pointer;
    padding: 0;
    position: absolute;
    top: 93%;
    left: 13px;
}

#nav-icon1 {
    position: relative;
    width: 30px;
    height: 24px;
    transform: rotate(0deg);
    transition: 0.5s ease-in-out;
    cursor: pointer;
}

#nav-icon1 span {
    display: block;
    position: absolute;
    height: 4px;
    width: 30px;
    background: #fff;
    border-radius: 9px;
    opacity: 1;
    left: 0;
    transform: rotate(0deg);
    transition: 0.25s ease-in-out;
}

#nav-icon1 span:nth-child(1) {
    top: 0px;
}

#nav-icon1 span:nth-child(2) {
    top: 10px;
}

#nav-icon1 span:nth-child(3) {
    top: 20px;
}

#nav-icon1.open span:nth-child(1) {
    top: 10px;
    transform: rotate(135deg);
}

#nav-icon1.open span:nth-child(2) {
    opacity: 0;
    left: -60px;
}

#nav-icon1.open span:nth-child(3) {
    top: 10px;
    transform: rotate(-135deg);
}

.sidebar img {
    width: 34px;
    height: 103px;
    margin-left: 10px;
}

.header-wrapper {
    margin-top: 30px;
    margin-bottom: 30px;
}

.start-wrapper {
    text-align: center;
    place-items: center;
    place-content: center;
}

.chatbot-wrapper {
    width: 50%;
    text-align: center;
    place-items: center;
    place-content: center;
    overflow: hidden;
    display: flex;
    flex-wrap: nowrap;
    flex-direction: column;
    margin-top: 60px;
    min-height: calc(100vh - 200px);
}

.messages-wrapper {
    border-bottom: 1px solid #DDDDDD;
    width: 100%;
    padding-top: 30px;
    padding-bottom: 30px;
    text-align: left !important;
    display: flex;
    flex-direction: row;
}

.main-title {
    margin-bottom: 50px;
    font: normal normal 600 42px/50px Cormorant Garamond;
    letter-spacing: -1.26px;
    color: #4D5255;
}

.subtitle {
    margin-bottom: 50px;
    letter-spacing: -0.36px;
    color: #3C3C3C;
    font: normal normal normal 18px/32px Inter;
}

.logo {
    width: 320px;
}

.chat-bot-wrapper {
    width: 800px;
}

.input-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
}

.input-wrapper-row {
    width: 100%;
    margin-top: auto;
}

.search-btn {
    background-color: #fff;
    float: right;
    width: 60px;
    height: 60px;
    border-radius: 50%;
    border: 0px;
    padding: 0px;
    cursor: pointer;
}

.arrow-image {
    width: 60px;
    height: 60px;
    padding: 0px;
    transform: rotate(270deg);
    filter: invert(80%) sepia(0%) saturate(43%) hue-rotate(141deg) brightness(98%) contrast(101%);
}

.arrow-image:hover {
    filter: invert(70%) sepia(81%) saturate(549%) hue-rotate(158deg) brightness(81%) contrast(88%);
}

.question-input {
    border: 0px;
    background-color: #f5f5f5 !important;
    width: 100%;
    float: left;
    font-size: 18px;

}

.question-input:focus {
    outline: none;
}

.input-group {
    border: 1px solid #c7c7c7;
    background-color: #F5F5F5 !important;
    border-radius: 20px;
    width: 100%;
    font-size: 18px;
    padding: 10px;
    align-items: center;
    display: flex;
    justify-content: space-between;
    margin-top: 30px;
}

.loader {
    font-size: 24px;
    float: right;
    padding: 10px;
    margin: 10px;
    border: 0px !important;
    width: 100% !important;
}

.main-wrapper {
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    justify-content: center;
    align-items: center;
    min-height: calc(100vh - 100px);
}

.footer-wrapper {
    padding-top: 25px;
    font-size: 15px;
    letter-spacing: -0.3px;
    color: #3C3C3C;
    font-family: Inter !important;
}

.footer-wrapper a {
    color: #3C3C3C;
    font-family: Inter !important;
}

.link {
    color: #3C3C3C;
    text-decoration: none;
}

.dot {
    height: 5px;
    width: 5px;
    background-color: #41ABC4;
    border-radius: 50%;
    display: inline-block;
}

.user-wrapper {
    text-align: center;
}

.avatar {
    width: 70px;
    height: 70px;
    border-radius: 50%;
}

.chat-wrapper {
    width: 100%;
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    justify-content: center;
    overflow: scroll;
}

.message-avatar .avatar {
    width: 36px;
    height: 36px;
    border-radius: 50%;
}

.message-content {
    padding-left: 15px !important;
    text-align: left;
    font: normal normal normal 18px/32px Inter;
    letter-spacing: -0.36px;
    color: #3C3C3C;
}

/* HTML: <div class="loader"></div> */
.loader {
    color: #b5b5b5;
    width: 4px !important;
    padding: 0 !important;
    align-items: center;
    aspect-ratio: 1;
    border-radius: 50%;
    box-shadow: 19px 0 0 7px, 38px 0 0 3px, 57px 0 0 0;
    transform: translateX(-38px);
    animation: l21 .5s infinite alternate linear;
}

@keyframes l21 {
    50% {
        box-shadow: 19px 0 0 3px, 38px 0 0 7px, 57px 0 0 3px
    }

    100% {
        box-shadow: 19px 0 0 0, 38px 0 0 3px, 57px 0 0 7px
    }
}

.message-content-loader {
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    justify-content: center;
    align-items: center;
    text-align: center;
}

.loading {
    border: 0 !important;
}

.beta {
    height: 40px;
    width: 100px;
    background-color: #B465D8;
    border-radius: 24px;
    text-align: center;
    padding-top: 5px;
    margin-left: 30px;
    top: -15px;
    position: absolute;
    color: #fff;
    font-size: 26px;
    font-family: Barlow;
    letter-spacing: 0.31px;
}

.register-link-wrapper {
    display: flex;
    justify-content: space-evenly;
    align-items: center;
}

.pool-member {
    height: 200px;
    width: 200px;
    font-size: 26px;
    font-family: Inter;
    border-radius: 20px;
    border: 1px solid #b5b5b5;
}

.client {
    height: 200px;
    width: 200px;
    font-size: 26px;
    font-family: Inter;
    border-radius: 20px;
    border: 1px solid #b5b5b5;
}

.pool-member:hover {
    border-color: #B465D8;
    color: #B465D8
}

.client:hover {
    border-color: #B465D8;
    color: #B465D8
}

.di-link {
    text-decoration: underline;
}

.menu-links {
    position: absolute;
    top: 86%;
    left: 13px;
}

.menu-links a {
    color: #fff;
    display: block;
    font-size: 18px;
    padding-bottom: 3px;
}

@media (max-width: 576px) {
    .logo {
        width: 50%;
    }

    .beta {
        height: 19px;
        width: 52px;
        top: -20px;
        position: absolute;
        font-size: 12px;
        margin-left: 7px;
    }

    .register-link {
        right: 8vw !important;
    }

    .main-title {
        font: normal normal 600 25px/38px Cormorant Garamond;
    }

    .subtitle {
        font: normal normal normal 13px/32px Inter;
    }

    .sidebar {
        display: none;
    }

    .chatbot-wrapper {
        width: 100% !important;
        margin-top: 0;
    }

    .message-content {
        padding-left: 34px !important;
    }
}

@media (max-width: 1900px) {
    .message-content {
        padding-left: 20px !important;
    }
}

@media (max-width: 1200px) {
    .message-content {
        padding-left: 35px !important;
    }
}
</style>
